import React, { memo, useContext } from 'react'
import { CircleTickMinor } from '@shopify/polaris-icons'
import { ContractorStatus } from 'src/constants/contractor/enums'
import { ContractorStatusChip } from './ContractorStatusChip'
import { ContractorsTableContext } from '../contractors-table/ContractorsTable.context'
import { TableSelect } from 'src/components/shared/table/TableSelect'

const statuses = [
  {
    value: ContractorStatus.Active,
    component: <ContractorStatusChip status={ContractorStatus.Active} />,
  },
  {
    value: ContractorStatus.Deactivated,
    component: <ContractorStatusChip status={ContractorStatus.Deactivated} />,
  },
  {
    value: ContractorStatus.ExpiresSoon,
    component: <ContractorStatusChip status={ContractorStatus.ExpiresSoon} />,
  },
]

const ContractorStatusSelectComponent = () => {
  const { statusFilter, setStatusFilter } = useContext(ContractorsTableContext)

  return (
    <TableSelect<ContractorStatus>
      title="Status"
      selectedValues={statusFilter}
      icon={<CircleTickMinor width={20} />}
      options={statuses}
      onSelect={setStatusFilter}
      triggerDataTestId="contractors-list-main-status-menu-btn"
      clearAllDataTestId="contractors-list-main-status-clear-all"
    />
  )
}

export const ContractorStatusSelect = memo(ContractorStatusSelectComponent)
